import React from 'react'
import { Checkbox, Flex, List } from 'antd-mobile'

import { formatMoney } from '../../components/common/utils'

import styles from '../../pages/PriceList/PriceList.module.css'

const PriceItem = ({ item, checked, toggleSelect }) => {
  const hasDiscount = item.discountPrice != null && Number(item.discountPrice) !== Number(item.price)

  return (
    <List.Item
      align="bottom"
      thumb={<Checkbox onChange={(e) => toggleSelect(item.skuId, e.target.checked)} checked={checked} />}
      wrap
    >
      {item.title}
      <List.Item.Brief>
        <Flex justify="between">
          <span>
            {hasDiscount && (
              <span style={{ textDecoration: 'line-through', color: '#999', marginRight: 8, fontSize: '0.72rem' }}>
                {formatMoney(item.price, item.currencyType)}
              </span>
            )}
            <span className={styles.price}>
              {formatMoney(hasDiscount ? item.discountPrice : item.price, item.currencyType)}
            </span>
          </span>
        </Flex>
      </List.Item.Brief>
    </List.Item>
  )
}

export default PriceItem
